import { Video, FileText, ClipboardList, Link as LinkIcon, ExternalLink, Trash2 } from "lucide-react";

import { detectLinkCategory, linkTypeMeta } from "../../../constants/taskboardLinks";

// Typed external-link card (product rule 7). The type is taken from the
// stored category, or auto-detected from the URL as a fallback, and
// drives the icon + label. Shows title, added-by + date, open-external,
// and a remove action (confirmed by the parent).
const ICONS = { Video, FileText, ClipboardList, LinkIcon };

function fmtDate(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

const LinkCard = ({ link, canModify = false, onRemove, onEdit }) => {
  const category = link.category || detectLinkCategory(link.url);
  const meta = linkTypeMeta(category);
  const Icon = ICONS[meta.icon] || LinkIcon;
  const addedBy = link.created_by?.name || "";

  return (
    <div className="group bg-white border border-[#E4E9F0] rounded-[10px] p-3 flex items-start gap-3 hover:shadow-md transition-shadow">
      <span className="w-9 h-9 rounded-lg flex items-center justify-center flex-none" style={{ background: meta.bg, color: meta.color }}>
        <Icon className="w-4.5 h-4.5" />
      </span>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <a
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[13.5px] font-semibold text-[#101828] hover:text-[#1866CC] truncate"
          >
            {link.title || link.url}
          </a>
          <span className="text-[10px] font-semibold px-1.5 py-px rounded-full flex-none" style={{ background: meta.bg, color: meta.color }}>
            {meta.label}
          </span>
        </div>
        <p className="text-[11.5px] text-[#98A2B3] truncate">{link.url}</p>
        <p className="text-[11px] text-[#98A2B3] mt-0.5">
          {addedBy ? `Added by ${addedBy}` : "Added"}{fmtDate(link.created_at) ? ` · ${fmtDate(link.created_at)}` : ""}
        </p>
      </div>
      <div className="flex items-center gap-1 flex-none">
        <a href={link.url} target="_blank" rel="noopener noreferrer" className="w-7 h-7 flex items-center justify-center rounded hover:bg-[#F2F4F7] text-[#667085]" title="Open link">
          <ExternalLink className="w-4 h-4" />
        </a>
        {canModify && (
          <>
            {onEdit && (
              <button onClick={() => onEdit(link)} className="text-[11px] text-[#1866CC] px-1 hover:underline opacity-0 group-hover:opacity-100">
                Edit
              </button>
            )}
            <button onClick={() => onRemove && onRemove(link)} className="w-7 h-7 flex items-center justify-center rounded hover:bg-red-50 text-[#B91C1C]" title="Remove link">
              <Trash2 className="w-4 h-4" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default LinkCard;
